import React from "react";

const aboutPilotPokerRun = <div>
    <h2>Pilot Poker Run</h2>
    <p>
        Pilot Poker Run is a friendly flying event with a track that covers a set of airports or waypoints. Each
        aircraft receives a playing card at each waypoint, and at the end of the run this will be evaluated as a hand in
        poker. The crew with the highest hand wins the informal competition.
    </p>
</div>

export default aboutPilotPokerRun